import { useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Box } from '../../widgets'
import { SelectableList } from '../../forms'
import { Teams } from '../team'
import { industries, isPartner } from '../../../lookups'
import { OrganisationCompany } from '../partner'

export const Industry = ({ active }) => {
  const request = useRequest('tenant')
  const { company: { industry }, subscription } = useView('tenant')
  const { push } = useStack()

  useShell({ active, mode: 'navigate narrow' })
  useBackground().set(mobile => ({ active, fade: false, ...onboardBackground(true, mobile) }))

  const handleCompanyIndustry = ({ industry }) => {
    if(industry !== undefined) {
      return request('companyUpdated', { industry }).then(() => push(isPartner(subscription) ? OrganisationCompany : Teams))
    }
  }

  return (
    <InputScreen
      onSubmit={handleCompanyIndustry}
      formValues={{ industry }}
      footerButton="Next"
      title="Industry type"
      description="What industry does your organisation work within? Choose the one that best fits your business"
      minHeight={0}
    >
      <Box grow overflow="hidden">
        <Box overflow="auto" py={8}>
          <SelectableList name="industry" list={industries.map(({ name }) => name)}/>
        </Box>
      </Box>
    </InputScreen>
  )
}